import checkUnit from '../utils/checkUnit.js';

/**
 * Converts a map scale (1:scale) into a map resolution.
 *
 * Formula reference:
 * resolution = scale / (inchesPerMeter * metersPerUnit * (mmPerInch / pixelSizeMm))
 * This uses the standard pixel size of 0.28 mm/pixel.
 *
 * @param {number} scale - The map scale denominator (e.g. 5000 for 1:5000).
 * @returns {number} The map resolution in map units per pixel.
 */
export default function getResolutionFromScale(scale) {
  if (typeof scale !== 'number' || isNaN(scale) || scale <= 0) {
    console.warn('getResolutionFromScale: invalid scale value');
    return 0;
  }

  const metersPerUnit = checkUnit('m'); // projection conversion factor
  const inchesPerMeter = 39.37;
  const mmPerInch = 25.4;
  const pixelSizeMm = 0.28;

  const resolution = parseFloat(scale) / (inchesPerMeter * metersPerUnit * (mmPerInch / pixelSizeMm));
  return resolution;
}
